import { SUPER_ADMINS } from './Consts'

export function isSuperUserEmail(u) {
  return SUPER_ADMINS.includes(u?.email || '')
}
